<template>
  <q-tab-pane name="notes">
    <note-input
      :notes="notes"
      :createNoteMethod="handleCreateNote"
      :updateNoteMethod="handleUpdateNote"
      :deleteNoteMethod="handleDeleteNote"
      style="height: 100%"
    />
  </q-tab-pane>
</template>

<script>
  import NoteInput from 'components/Common/Inputs/NoteInput/NoteInput.vue'
  import { mapActions } from 'vuex'

  export default {
    props: {
      customer: {
        type: Object,
        required: true
      }
    },

    computed: {
      hasNotes () {
        return this.customer.notes && this.customer.notes.data.length > 0
      },

      notes () {
        if (!this.hasNotes) {
          return []
        }

        return this.customer.notes.data
      }
    },

    methods: {
      ...mapActions(['createCustomerNote', 'deleteCustomerNote', 'updateCustomerNote']),

      handleCreateNote (data) {
        return this.createCustomerNote({
          customerId: this.customer.id,
          type: this.customer.type,
          data
        })
      },

      handleUpdateNote (noteId, data) {
        return this.updateCustomerNote({
          customerId: this.customer.id,
          note: data,
          noteId
        })
      },

      handleDeleteNote (noteId) {
        return this.deleteCustomerNote({
          customerId: this.customer.id,
          noteId
        })
      }
    },

    components: {
      NoteInput
    }
  }
</script>
